<script>
    import Clipboard from 'svelte-clipboard'
    import type { ISourceSettings } from '../lib/types'
    import ObsButton from './ObsButton.svelte'

    export let setting: ISourceSettings

    let statusMessage = ''

    let blurred = {
        chat: true,
        hypetrain: true,
    }

    async function handleRefresh() {
        const type = setting.type
        const createOrUpdate = setting.key ? 'update' : 'create'

        await setting.method(createOrUpdate, type)
        statusMessage = 'Generated a new URL'
    }

    function handleBlur() {
        if (!setting.key) {
            return
        }

        blurred[setting.type] = !blurred[setting.type]
    }
</script>

<div class="bg-white overflow-hidden shadow rounded-lg col-span-1 p-5">
    <label
        for="email"
        class="block text-sm font-medium leading-5 text-gray-700">{setting.title}</label>
    <div class="mt-1 flex rounded-md shadow-sm">
        <div class="relative flex items-stretch flex-grow focus-within:z-10">
            <div
                class:hidden={!blurred[setting.type]}
                on:click={handleBlur}
                class="absolute block my-px py-px w-full cursor-pointer rounded-none rounded-l-md inset-y-0 left-0 flex-grow items-center">
                <div
                    class="flex flex-row h-full w-full justify-center items-center text-gray-800">
                    <svg
                        class="h-5 w-5 mr-2"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                        fill="currentColor">
                        <path d="M10 12a2 2 0 100-4 2 2 0 000 4z" />
                        <path
                            fill-rule="evenodd"
                            d="M.458 10C1.732 5.943 5.522 3 10 3s8.268 2.943 9.542 7c-1.274 4.057-5.064 7-9.542 7S1.732 14.057.458 10zM14 10a4 4 0 11-8 0 4 4 0 018 0z"
                            clip-rule="evenodd" />
                    </svg>
                    <span>Click to reveal</span>
                </div>
            </div>
            <input
                on:click={handleBlur}
                id={`${setting.type}`}
                readonly
                value={setting.url + '/' + setting.key}
                class="{blurred[setting.type] ? 'text-shadow-blur' : ''} form-input block w-full pr-0 rounded-none rounded-l-md transition-all ease-in-out duration-300 sm:text-sm sm:leading-5"
                placeholder="Generate a private key" />
        </div>

        <Clipboard
            text={setting.url + '/' + setting.key}
            let:copy
            on:copy={() => {
                statusMessage = 'Copied to clipboard!'
            }}>
            <button
                on:click={copy}
                title="Copy to clipboard"
                class="-ml-px relative inline-flex items-center px-2 py-2 border border-gray-300 text-sm leading-5 font-medium  text-gray-700 bg-gray-50 hover:text-gray-500 hover:bg-white focus:outline-none  transition ease-in-out duration-150">
                <svg
                    class="h-5 w-5 text-gray-400"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                    fill="currentColor">
                    <path d="M8 2a1 1 0 000 2h2a1 1 0 100-2H8z" />
                    <path
                        d="M3 5a2 2 0 012-2 3 3 0 003 3h2a3 3 0 003-3 2 2 0 012 2v6h-4.586l1.293-1.293a1 1 0 00-1.414-1.414l-3 3a1 1 0 000 1.414l3 3a1 1 0 001.414-1.414L10.414 13H15v3a2 2 0 01-2 2H5a2 2 0 01-2-2V5zM15 11h2a1 1 0 110 2h-2v-2z" />
                </svg>
            </button>
        </Clipboard>
        <button
            title="Refresh key"
            on:click={handleRefresh}
            class="-ml-px relative inline-flex items-center px-2 py-2 border border-gray-300 text-sm leading-5 font-medium  text-gray-700 bg-gray-50 hover:text-gray-500 hover:bg-white focus:outline-none  transition ease-in-out duration-150">
            <svg
                class="h-5 w-5 text-gray-400"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor">
                <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
            </svg>
        </button>
        <ObsButton
            on:click={() => {
                statusMessage = 'Drag this button into OBS to automatically create a source'
            }}
            name={`${setting.type}-source`}
            width={setting.width}
            height={setting.height}
            id={`${setting.type}-source`}
            url={setting.url}
            key={setting.key} />
    </div>
    <p class="mt-2 text-sm text-gray-500" id="email-description">
        {statusMessage}
    </p>

    <!-- {#if setting.key}
        <div>
            <div class="mt-2 md:grid md:grid-cols-2 md:gap-2">
                <div class="col-auto">
                    <label
                        for="chat-width"
                        class="block text-sm font-medium leading-5 text-gray-700">Width
                    </label>
                    <input
                        id="chat-width"
                        type="number"
                        class="mt-1 form-input block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                        bind:value={setting.width} />
                </div>

                <div class="col-auto">
                    <label
                        for="chat-height"
                        class="block text-sm font-medium leading-5 text-gray-700">Height
                    </label>
                    <input
                        id="chat-height"
                        type="number"
                        class="mt-1 form-input block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                        bind:value={setting.height} />
                </div>

                <div class="col-span-2 text-right">
                    <ObsButton
                        name={`${setting.type}-source`}
                        width={setting.width}
                        height={setting.height}
                        id={`${setting.type}-source`}
                        url={setting.url}
                        key={setting.key} />
                </div>
            </div>
        </div>
    {/if} -->
</div>

<style lang="postcss">
</style>
